module.exports = __webpack_public_path__ + "static/img/photo_2023-10-26_15-28-40.17a1cb39.jpg";